export default {"src":"/_next/static/media/qualityPieMobile.de2cd4a7.svg","height":398,"width":457,"blurWidth":0,"blurHeight":0};